module.exports = __webpack_public_path__ + "img/claimpending.eb1a9478.svg";